import { Switch } from 'antd';

import { Button } from '../../../../components/ui';
import { useT } from '../../../../i18n';
import { Khoi, type TabProps } from './chung';

/**
 * Tab Nâng cao. Native có thêm "Nhân bản sang phòng ban khác" — platform không có trục phòng ban (một tenant = một tổ
 * chức) nên khối ấy bỏ hẳn.
 */
export function TabNangCao({ f, dat, suaDuoc, onXoa }: TabProps & { onXoa?: () => void }) {
  const { t } = useT();
  return (
    <div className="space-y-4">
      <Khoi ten={t('troLyAiBot.mucKhac')}>
        <label className="flex items-center gap-2 text-xs">
          <Switch size="small" checked={f.saveHistory} disabled={!suaDuoc} onChange={(v) => dat('saveHistory', v)} />
          {t('troLyAiBot.luuLichSu')}
        </label>
      </Khoi>

      {/* Xoá nằm cuối tab cuối, tách khỏi thanh Lưu: đặt cạnh nút hay bấm nhất là mời bấm nhầm. */}
      {onXoa ? (
        <section className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-danger-500 p-4">
          <div className="min-w-0">
            <h3 className="text-sm font-semibold text-danger-700">{t('troLyAiBot.vungNguyHiem')}</h3>
            <p className="mt-0.5 text-xs leading-relaxed text-content-secondary">{t('troLyAiBot.xacNhanXoaGhi')}</p>
          </div>
          <Button size="sm" variant="destructive" onClick={onXoa}>
            {t('troLyAiBot.xoaChatbot')}
          </Button>
        </section>
      ) : null}
    </div>
  );
}
